import React from 'react';
import { useHistory } from 'react-router-dom';
const Header2 = () => {
  let history =useHistory();
    const logout =()=>{
        history.push("/shops/login");
    };
    
      const nav = {
        background: "#222"
      };
      const logoutbutton = {
        border: "1px solid #df2933",
        color: "#df2933",
        padding: "7px 15px",
        width: "90px",
        transition: "0.4s",
        marginTop: "15px",
        marginRight: "20px"
      }; 
      const orderbutton = {
        border: "1px solid #3366ff",
        color: "#3366ff",
        padding: "7px 10px",
        width: "80px",
        marginTop: "15px",
        transition: "0.4s",
        marginRight: "20px"
      };  
      const order =()=>{
        history.push(`/shops/order`);
    }; 
    return(        
        <nav className="navbar navbar-expand-lg navbar-dark teal mb-4" style={nav}>
            <a className="navbar-brand" href="/CloudCart-Preview/#/shops/Dash"><img src={process.env.PUBLIC_URL + "/images/logo_new.png"} alt="Cloudcart" height="50px" width="200px" style={{marginTop:"5px"}} className="logo"/>
            </a>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse " id="navbarSupportedContent">
            <ul className="navbar-nav mr-auto">
                    <li className="nav-item dropdown">
                    </li>
                </ul>
            <button
                    type="button"
                    className="btn btn-outline-dark"
                    style={orderbutton}
                >
                    <i 
                        className="fas fa-shopping-bag"
                        id="order-logo"
                        data-toggle="modal"
                        data-target="#oreder"
                        onClick={order}>
                    </i>
              </button>
                <button type="button" className="btn btn-outline-dark pull-right" style={logoutbutton} onClick={logout}>Logout</button>
            </div>
        </nav>
    );
};

export default Header2;